import { LEARN } from 'constants/actionTypes';

const initialState = true;

export default (state = initialState, action) => {
  switch (action.type) {
    case LEARN.CONTENTS.REQUEST:
      return true;

    case LEARN.CONTENTS.RECEIVE:
    case LEARN.CONTENTS.REQUEST_ERROR:
      return false;

    default:
      return state;
  }
};
